import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
export const SvgGoalBonusDimension = {
  height: 16,
  width: 16,
  viewBox: '0 0 16 16',
};
export const SvgGoalBonus = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
    <g clipPath="url(#clip0_goal_bonus)">
      <mask
        id="mask0_goal_bonus"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <path
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
          fill="#B90B13"
        />
      </mask>
      <g mask="url(#mask0_goal_bonus)">
        <path
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
          fill="#EEC880"
        />
      </g>
      <path
        d="M8.0002 1.2002C4.2466 1.2002 1.2002 4.24659 1.2002 8.00021C1.2002 11.7538 4.2466 14.8002 8.0002 14.8002C11.7538 14.8002 14.8002 11.7538 14.8002 8.00021C14.8002 4.24659 11.7538 1.2002 8.0002 1.2002ZM8.6802 3.44419L9.5982 2.7982C10.8358 3.17899 11.8898 3.99499 12.5766 5.06939L12.3114 5.98058L11.3934 6.29339L8.6802 4.39618V3.44419ZM6.4022 2.7982L7.3202 3.44419V4.39618L4.607 6.29339L3.689 5.98058L3.4238 5.06939C4.1106 4.00179 5.1646 3.18579 6.4022 2.7982ZM4.6546 11.475L3.8794 11.543C3.0566 10.591 2.5602 9.35341 2.5602 8.00021C2.5602 7.91861 2.567 7.84381 2.5738 7.76221L3.2538 7.26578L4.1922 7.59221L5.185 10.5434L4.6546 11.475ZM9.7002 13.1614C9.163 13.3382 8.5918 13.4402 8.0002 13.4402C7.4086 13.4402 6.8374 13.3382 6.3002 13.1614L5.831 12.1482L6.2662 11.4002H9.741L10.1762 12.155L9.7002 13.1614ZM9.5438 10.0402H6.4566L5.5386 7.30658L8.0002 5.57938L10.4686 7.30658L9.5438 10.0402ZM12.121 11.543L11.3458 11.475L10.8086 10.5434L11.8014 7.59221L12.7466 7.27258L13.4266 7.76901C13.4334 7.84381 13.4402 7.91861 13.4402 8.00021C13.4402 9.35341 12.9438 10.591 12.121 11.543Z"
        fill="#191A1A"
      />
    </g>
    <defs>
      <clipPath id="clip0_goal_bonus">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
